import { render, staticRenderFns } from "./SellCoinsItem.vue?vue&type=template&id=42b28392&scoped=true&"
import script from "./SellCoinsItem.vue?vue&type=script&lang=ts&"
export * from "./SellCoinsItem.vue?vue&type=script&lang=ts&"
import style0 from "./SellCoinsItem.vue?vue&type=style&index=0&id=42b28392&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b28392",
  null
  
)

export default component.exports